const faq = {
    readyFn: function () {
        let self = this;
        self.faqInit();
    },

    faqInit: function () {
        $("#faq .question-reponse").click(function () {
            $(".reponse", this).slideToggle("200");
            $(".question .fleche", this).toggleClass("rotated");
        });
    },

};

export { faq };